import { useState } from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getIndexerErrorInfo } from '../../api/errors';
import { usePatchOnboardingMutation } from '../../api/indexerApi';
import { useOnboardingGate } from '../../lib/onboarding-guard';
import { useIndexerPaths } from '../../lib/indexer-paths';
import { useProject } from '../../lib/project-context';
import { formatFaNumber } from '../../lib/utils';
import { IndexerIcon } from '../IndexerIcon';

export function OnboardingCompleteStep({
  projectId,
  inspectCount,
  notIndexedCount,
  scheduleSaved,
}: {
  projectId: string;
  inspectCount: number;
  notIndexedCount: number;
  scheduleSaved: boolean;
}) {
  const navigate = useNavigate();
  const paths = useIndexerPaths();
  const { refresh } = useProject();
  const { markCompleted } = useOnboardingGate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [patchOnboarding] = usePatchOnboardingMutation();

  async function onEnterDashboard() {
    setBusy(true);
    setError(null);
    try {
      await patchOnboarding({ projectId, complete: true }).unwrap();
      markCompleted();
      try {
        await refresh();
      } catch {
        // ignore
      }
      navigate(paths.overview, { replace: true });
    } catch (err) {
      setError(
        getIndexerErrorInfo(err).message || 'تکمیل راه‌اندازی ناموفق بود',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card className="mb-3 border">
      <Card.Body className="text-center py-4">
        <div className="display-4 mb-3" aria-hidden>
          <IndexerIcon name="check-circle-fill" className="text-success" />
        </div>
        <h2 className="h5 mb-3">راه‌اندازی تکمیل شد</h2>
        <p className="text-body mb-4 fs--1">
          {formatFaNumber(inspectCount)} آدرس بازرسی شد؛{' '}
          {formatFaNumber(notIndexedCount)} ایندکس‌نشده شناسایی شد.
          {scheduleSaved
            ? ' زمان‌بندی پیگیری فعال است.'
            : ' زمان‌بندی را بعداً از بخش وضعیت ایندکس می‌توانید تنظیم کنید.'}
        </p>
        {error && (
          <Alert variant="danger" className="text-start small mb-0">
            {error}
          </Alert>
        )}
      </Card.Body>
      <Card.Footer className="bg-body-tertiary border-top d-flex justify-content-center py-3">
        <Button
          variant="falcon-primary"
          disabled={busy}
          onClick={() => void onEnterDashboard()}
        >
          {busy ? 'در حال ورود…' : 'ورود به نمای کلی'}
        </Button>
      </Card.Footer>
    </Card>
  );
}
